<template>
  <v-container class="booking-confirm p-0" v-if="bookingRecord">
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>

    <HkiaraceBannerFrame :src="'api/static/'+facilityType.banner"
                         :label="$t('booking_confirm.confirm_msg')">
      <v-container class="booking-confirm-content" fluid>
        <v-row>
          <v-col class="booking-confirm-title text-left">
            {{ $t('booking_confirm.summary') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field :label="$t('booking.reference_number')"
                          readonly
                          hide-details
                          :value="referenceNumberLabel"></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="paymentRecord && paymentRecord.payment_method === 'cyber_source'">
          <v-col cols="12" md="6">
            <v-text-field label="Payment Reference No."
                          readonly
                          hide-details
                          :value="$getPaymentRecordRefNo(paymentRecord)"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field :label="$t('booking.reserved_at')"
                          readonly
                          hide-details
                          :value="reservedAtLabel"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-input hide-details>
              <v-container fluid class="pa-0 flex-column">
                <legend class="v-label theme--light">{{ $t('booking.facility') }}</legend>
                <v-simple-table v-for="booking in sortedBookings"
                                :key="booking.id"
                                class="mb-4">
                  <tbody>
                  <tr>
                    <td>{{ $t('booking_confirm.date') }}</td>
                    <td>{{ $parseDate(booking.start_time, 'yyyy-MM-dd') }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('booking_confirm.time') }}</td>
                    <td>{{ $parseDate(booking.start_time, 'HH:mm') }} - {{ $parseDate(booking.end_time, 'HH:mm') }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('booking_confirm.item') }}</td>
                    <td>{{ booking.item.name }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('booking_confirm.price') }}</td>
                    <td>HKD {{ booking.fee }}</td>
                  </tr>
                  <tr v-if="booking.additional_items.length > 0">
                    <td>{{ $t('booking_confirm.additional_items') }}</td>
                    <td>
                      <div v-for="additional_item in booking.additional_items">
                        {{ additional_item.type.name }} x {{ additional_item.count }} - HKD {{ additional_item.type.price * additional_item.count }}
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </v-simple-table>

                <!--                <v-row v-for="booking in sortedBookings"-->
                <!--                       :key="booking.id">-->
                <!--                  <v-col cols="12" md="3">-->
                <!--                    <b>{{ booking.item.name }}</b>-->
                <!--                  </v-col>-->
                <!--                  <v-col cols="12" md="3" class="text-right">-->
                <!--                    <small class="form-text text-muted">{{ $parseDate(booking.start_time) + ' - ' + $parseDate(booking.end_time, 'HH:mm') }}</small>-->
                <!--                  </v-col>-->
                <!--                  <v-col cols="12">-->
                <!--                    &lt;!&ndash;                    <v-select :label="$t('booking.coupons')"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                              :items="couponOptions(booking)"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                              v-model="selectedCoupons[booking.id]"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                              :rules="couponRules(booking)"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                              dense></v-select>&ndash;&gt;-->
                <!--                  </v-col>-->
                <!--                </v-row>-->
              </v-container>
            </v-input>
          </v-col>
        </v-row>
        <!--        <v-row>-->
        <!--          <v-col>-->
        <!--            <v-textarea :label="$t('booking.facility')"-->
        <!--                        readonly-->
        <!--                        hide-details-->
        <!--                        auto-grow-->
        <!--                        no-resize-->
        <!--                        :rows="1"-->
        <!--                        :value="facilityLabel"></v-textarea>-->
        <!--          </v-col>-->
        <!--        </v-row>-->
        <!--        <v-row>-->
        <!--          <v-col>-->
        <!--            <v-text-field :label="$t('booking.coupons')"-->
        <!--                          readonly-->
        <!--                          hide-details-->
        <!--                          :value="couponLabel"></v-text-field>-->
        <!--          </v-col>-->
        <!--        </v-row>-->
        <v-row>
          <v-col>
            <v-text-field :label="$t('booking.fee')"
                          readonly
                          hide-details
                          :value="priceLabel"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field :label="$t('booking.second_contact_number')"
                          readonly
                          hide-details
                          :value="bookingRecord.second_contact_number"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="primary"
                   :to="{name: 'my-account', query: {t: 2}}">
              {{ $t('finish') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons'
import {DateTime} from 'luxon'
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import _ from "lodash";

library.add(faCheckCircle);

export default {
  name: 'BookingConfirm',
  components: {HkiaraceBannerFrame},
  data() {
    return {
      bookingRecordId: this.$route.params.bookingRecordId,
      bookingRecord: null,
      paymentRecord: null,
    };
  },
  mounted() {
    this.getBookingRecord();
  },
  computed: {
    facilityType() {
      return this.bookingRecord ? this.bookingRecord.bookings[0].item.type : null;
    },
    referenceNumberLabel() {
      return this.bookingRecord ? "BV" + this.bookingRecord.reference_number.toString().padStart(10, '0') : '';
    },
    reservedAtLabel() {
      return this.bookingRecord ? DateTime.fromISO(this.bookingRecord.create_at).toFormat('yyyy-MM-dd HH:mm') : '';
    },
    facilityLabel() {
      if (!this.bookingRecord) {
        return "";
      }

      let bookings = Array.from(this.bookingRecord.bookings);

      bookings.sort((a, b) => {
        if (a.start_time > b.start_time) {
          return 1;
        } else if (a.start_time < b.start_time) {
          return -1;
        } else {
          return 0;
        }
      });

      return bookings.map(function (b) {
        return DateTime.fromISO(b.start_time).toFormat('yyyy-MM-dd HH:mm') + ' - ' + DateTime.fromISO(b.end_time).toFormat('HH:mm') + "  " + b.item.name;
      }).join("\n")

      // return this.bookingRecord ? this.bookingRecord.bookings.map(function (b) {
      //   return DateTime.fromISO(b.start_time).toFormat('yyyy-MM-dd HH:mm') + ' - ' + DateTime.fromISO(b.end_time).toFormat('HH:mm') + "  " + b.item.name;
      // }).join("\n") : "";
    },
    couponLabel() {
      if (this.bookingRecord.used_coupons.length) {
        return this.bookingRecord.used_coupons.map(function (c) {
          return "HK$" + c.amount + " - " + DateTime.fromISO(c.create_at).toFormat('yyyy-MM-dd HH:mm') + " - " + c.from_booking.item.name;
        }).join("<br>");
      } else {
        return this.$t('booking.no_coupon');
      }
    },
    priceLabel() {
      let couponAmount = 0;

      // this.bookingRecord.used_coupons.forEach(function (c) {
      //   couponAmount += c.amount;
      // });

      return this.bookingRecord ? "HK$" + (this.bookingRecord.fee - couponAmount) : "";
    },
    sortedBookings() {
      return this.bookingRecord ? _.sortBy(this.bookingRecord.bookings, 'start_time') : [];
    },
  },
  methods: {
    getBookingRecord() {
      this.$callAPI('aafb/booking_record/', {booking_record_id: this.bookingRecordId}, function (response) {
        this.bookingRecord = response.body.record;
        this.paymentRecord = response.body.payment_record;
      });
    },
    next() {
      this.$router.push({name: 'my-account', query: {t: 2}});
    },
  },
}
</script>

<style lang="less">
.booking-confirm {
  .booking-confirm-content {
    max-width: 1000px;
    background-color: white;
    padding: 2rem;

    .booking-confirm-title {
      color: #8E765B;
      font-size: 1.5em !important;
    }

    .v-label {
      color: #8E765B;
    }

    .v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }

    .v-text-field > .v-input__control > .v-input__slot:after {
      display: none;
    }
  }

  .fa-check-circle {
    font-size: 5em;
  }

  @media (min-width: 992px) {
    font-size: 1.2em;

    .confirm-message-label {
      font-size: 2em !important;
    }

    .booking-summary-title {
      font-size: 2.5em !important;
    }
  }

  .confirm-message-label {
    font-size: 1.5em;
  }

  .booking-summary-title {
    text-align: left;
    font-size: 1.5em;
  }

  .booking-preview-form {
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 30px;

    .col-form-label {
      color: rgba(0, 0, 0, 0.5);
      text-align: left;
    }
  }
}
</style>
